/**
 * Theme based constants such as sizing and colors
 */

export const VERTICAL_WELL_GAP = 24

export const SETTINGS_WELL_FORM_LAYOUT = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
}
